import {
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip
} from 'chart.js'
import type { ChartType, TooltipPositionerFunction } from 'chart.js'

Chart.register(
  CategoryScale,
  Filler,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
)

declare module 'chart.js' {
  interface TooltipPositionerMap {
    cursorOffset: TooltipPositionerFunction<ChartType>
  }
}

Tooltip.positioners.cursorOffset = function (_elements, eventPosition) {
  if (!eventPosition) {
    return { x: this.caretX, y: this.caretY }
  }

  return { x: eventPosition.x, y: eventPosition.y }
}
